"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Binder {
    constructor(id, name, effectiveDate, usClassification, uniqueMarketReference, commissions, participartingInsurers) {
        this.id = id;
        this.name = name;
        this.effectiveDate = effectiveDate;
        this.usClassification = usClassification;
        this.uniqueMarketReference = uniqueMarketReference;
        this.commissions = commissions;
        this.participartingInsurers = participartingInsurers;
    }
    static fromObj(data) {
        return new Binder(data === null || data === void 0 ? void 0 : data.id, data === null || data === void 0 ? void 0 : data.name, data === null || data === void 0 ? void 0 : data.effectiveDate, data === null || data === void 0 ? void 0 : data.usClassification, data === null || data === void 0 ? void 0 : data.uniqueMarketReference, data === null || data === void 0 ? void 0 : data.commissions, data === null || data === void 0 ? void 0 : data.participartingInsurers);
    }
    static fromLegacyArgoBinder(data) {
        const commissions = [];
        commissions.push({
            type: "insuranceBroker",
            name: data.brokerName,
            percentage: data.brokerPercentage
        });
        commissions.push({
            type: "loadsure",
            name: "Loadsure",
            percentage: data.commissionPercentage
        });
        return new Binder("argo", "Argo", data.effectiveDate, data.usClassification, data.uniqueMarketReference, commissions);
    }
    getLoadsureCommissionPercentage() {
        var _a;
        const commission = this.commissions.find(({ type }) => type === "loadsure");
        return (_a = commission === null || commission === void 0 ? void 0 : commission.percentage) !== null && _a !== void 0 ? _a : 0;
    }
}
exports.default = Binder;
//# sourceMappingURL=binder.class.js.map